import Button from "@mui/material/Button";
import Modal from "components/modal/modal";
import { AppAction, AppContext } from "helpers/context";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import styles from "./delete-resource-modal.module.scss";

type ResourceKind = "dataSource" | "faq";

const I18N_CONFIG: Record<
  ResourceKind,
  {
    title: string;
    prefix: string;
    suffix: string;
    snackBarTitle: string;
    snackBarMessage: string;
  }
> = {
  dataSource: {
    title: "userSystem.deleteDataSource.title",
    prefix: "userSystem.deleteDataSource.prefix",
    suffix: "userSystem.deleteDataSource.suffix",
    snackBarTitle: "deleteDataSource",
    snackBarMessage: "deleteDataSourceSuccess",
  },
  faq: {
    title: "userSystem.deleteFaq.title",
    prefix: "userSystem.deleteFaq.prefix",
    suffix: "userSystem.deleteFaq.suffix",
    snackBarTitle: "deleteFaq",
    snackBarMessage: "deleteFaqSuccess",
  },
};

interface Props {
  data: { id: string; title: string };
  resourceType: ResourceKind;
  onConfirm: () => void;
  onClose: () => void;
}

const DeleteResourceModal: React.FC<Props> = ({
  data,
  resourceType,
  onConfirm,
  onClose,
}) => {
  const [t] = useTranslation();
  const [, dispatch] = useContext(AppContext);
  const cfg = I18N_CONFIG[resourceType];

  const handleConfirm = (): void => {
    dispatch({
      type: AppAction.addSnackBarParams,
      payload: {
        title: cfg.snackBarTitle,
        message: cfg.snackBarMessage,
      },
    });
    onConfirm();
    onClose();
  };

  return (
    <Modal header={t(cfg.title)} opened={!!data.id} onClose={onClose}>
      <div className={styles.info}>
        <div className={styles.text}>
          {`${t(cfg.prefix)}${data.title}${t(cfg.suffix)}`}
        </div>
        <div className={styles.button}>
          <Button
            variant="text"
            color="success"
            onClick={onClose}
            style={{ outline: "none" }}
          >
            {t("buttons.cancel")}
          </Button>
          &nbsp;&nbsp;
          <Button variant="contained" color="error" onClick={handleConfirm}>
            {t("buttons.delete")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteResourceModal;
